import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  client: {
    VITE_API_URL: z
      .string()
      .min(1, "API URL is required")
      .refine(
        (url) => url.startsWith("http://") || url.startsWith("https://") || url.startsWith("/"),
        "API URL must be a valid URL or absolute path",
      ),
    VITE_BETTER_AUTH_URL: z.url(),
    VITE_METABASE_URL: z.string().default("http://localhost:3001"),
  },

  clientPrefix: "VITE_",
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
